import { useQuery } from '@tanstack/react-query';
import { useModulesStore } from '@wkda/funnel-components';
export const useGetManufacturers = params => {
  const {
    carTypesModule: {
      getManufacturers
    }
  } = useModulesStore();
  const queryKey = ['manufacturer', params].filter(Boolean);
  const query = useQuery({
    queryKey,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    queryFn: () => getManufacturers(params)
  });
  return {
    ...query,
    data: query.data ?? []
  };
};